































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { CapabilityCategory, Capability } from '@/models/hcad/shared/dashboard';
import DynamicIcon from '@/components/DynamicIcon.vue';

import { displayLength } from '@/utils/text-util';

@Component({
    components: {
        DynamicIcon,
    }
})
export default class MetricsGroup extends Vue
{
    @Prop({ default: new CapabilityCategory() }) readonly category!: CapabilityCategory;
    @Prop(Boolean) readonly allowTargetSelection!: boolean;
    @Prop(Array) readonly metricRange!: [number, number];
    @Prop(Boolean) readonly forceTwoLineTitle!: boolean;

    get metrics()
    {
        return this.category.capabilities;
    }

    groupHeight()
    {
        // Top-level button margin
        let height = 4 * (this.metrics.length - 1);

        for(const metric of this.metrics)
        {
            // Top-level capability button height
            height += (metric.selected && this.allowTargetSelection) ? 60 : 35;
            if (metric.expanded)
            {
                for(const sm of metric.subCapabilities)
                {
                    // Sub-capability button margin
                    height += (sm.selected && this.allowTargetSelection) ? 60 : 25;
                }
            }
        }

        return Math.max(
            height,
            (this.category.name.length > 7 ? 100 : 74) // allow for long category names with 1 or 2 capabilities
        );
    }

    get shouldWrapTitle()
    {
        const twoLineCharLimit = 17.95 + Math.max(0, (this.metrics.length - 3) * 5.9);
        return displayLength(this.category.name.toUpperCase()) > twoLineCharLimit;
    }

    get twoLineTitle()
    {
        return this.forceTwoLineTitle || this.shouldWrapTitle;
    }

    async expandSubcapabilities(ev: Event, m: Capability)
    {
        ev.stopPropagation();
        ev.preventDefault();
        ev.stopImmediatePropagation();
        m.expanded = !(m.expanded);
        this.$forceUpdate();
        await this.$nextTick();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.$refs.mgroup as any).focus();
        await this.$nextTick();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.$refs.mgroup as any).blur();
    }

    selectCapability(m: Capability)
    {
        m.selected = !(m.selected);
        this.$forceUpdate();
        this.$emit('input', m);
    }

    capabilityTargetUpdated(m: Capability)
    {
        this.$forceUpdate();
        this.$emit('input', m);
    }
}
